var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f9ed32;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.06,29.64v-13.38c-2.46,1.91-4.11,2.87-4.96,2.87-.41,0-.77-.16-1.08-.49s-.47-.71-.47-1.14c0-.5,.15-.87,.46-1.1s.86-.54,1.64-.91c1.17-.56,2.11-1.15,2.81-1.76s1.32-1.31,1.86-2.07,.89-1.23,1.06-1.41,.47-.26,.93-.26c.51,0,.92,.2,1.23,.6s.46,.96,.46,1.66V29.07c0,1.97-.66,2.96-1.99,2.96-.59,0-1.06-.2-1.42-.6s-.54-.99-.54-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.45,21.12c0,1.61-.1,2.99-.29,4.15s-.55,2.21-1.07,3.15c-.66,1.16-1.51,2.05-2.55,2.68s-2.21,.94-3.48,.94c-1.47,0-2.79-.42-3.95-1.26s-2.04-2.01-2.63-3.5c-.3-.81-.52-1.71-.66-2.7s-.21-2.05-.21-3.2c0-1.48,.08-2.81,.23-4s.4-2.21,.73-3.06c.57-1.41,1.4-2.49,2.49-3.23s2.39-1.11,3.9-1.11c1,0,1.9,.16,2.71,.49s1.53,.81,2.14,1.44,1.13,1.41,1.56,2.34c.74,1.62,1.1,3.91,1.1,6.87Zm-3.98-.29c0-1.79-.11-3.26-.32-4.4s-.57-2-1.07-2.59-1.2-.87-2.09-.87c-1.28,0-2.16,.65-2.66,1.96s-.75,3.31-.75,6.03c0,1.84,.11,3.35,.32,4.53s.57,2.07,1.07,2.67,1.18,.9,2.05,.9,1.59-.31,2.09-.94,.86-1.52,1.06-2.69,.3-2.7,.3-4.59Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT10);
export default __webpack_public_path__ + "static/media/T10.a293407018eda72f4840160fc2000e87.svg";
export { ForwardRef as ReactComponent };